<app-progress-bar />
@if (isAuthRoute()) {
  <router-outlet />
} @else {
  <app-navigation />
}
